export function init() {
    const menu = document.getElementById('mobile-list');
    const menuBtn = document.getElementById('menu-button');

    const toggleMenuBtn = () => {
        const children = Array.prototype.slice.call(menuBtn.children);
        children.forEach((child) => {
            child.classList.toggle('hidden');
        });
    }

    document.addEventListener('click', (event) => {
        if (event.target.id === 'menu-botton' || event.target.closest('#menu-button')) {
            toggleMenuBtn();
            menu.style.maxHeight ? menu.style.maxHeight = null : menu.style.maxHeight = menu.scrollHeight + 'px';
            return;
        }

        if (!menu.contains(event.target) && menu.style.maxHeight) {
            menu.style.maxHeight = null;
            toggleMenuBtn();
        }
    });

    document.querySelectorAll('.has-children').forEach((item) => {
        item.addEventListener('click', () => {
            menu.style.maxHeight = '100%';
            setTimeout(() => {
                menu.style.maxHeight = menu.scrollHeight + 'px';
            }, 200);
            item.nextElementSibling.classList.toggle('hidden');
            const children = Array.prototype.slice.call(item.children);
            children.forEach((child) => {
                if (child.classList.contains('arrow-down')) {
                    child.classList.toggle('transform');
                    child.classList.toggle('rotate-180');
                }
            })
        })
    });
}
